import React, { useState } from 'react';
import { MdOutlineQuiz, MdOutlineInsights, MdAccessTime } from 'react-icons/md';
import Helmet from 'components/Helmet';
import Button from 'components/Button';
import TestFinderAuth from 'components/TestFinderAuth';
import './index.css';

function TestFinder() {
    const [showAuthModal, setShowAuthModal] = useState(false);

    const handleStartClick = () => {
        setShowAuthModal(true);
    };

    return (
        <div className='layout'>
            <Helmet
                title='SAT or ACT? - The SAT Crash Course'
                description='Not sure whether SAT or ACT is right for you? Take our free diagnostic test to find out which test suits you better!'
            />
            
            <div className='testFinder'>
                <h1 className='testFinder__title'>
                    SAT or ACT?
                </h1>
                
                <div className='testFinder__card'>
                    <div className='testFinder__feature'>
                        <MdOutlineQuiz className='testFinder__featureIcon' />
                        <div className='testFinder__featureContent'>
                            <h3 className='testFinder__featureTitle'>Quick Diagnostic</h3>
                            <p className='testFinder__featureDesc'>
                                Answer 28 questions covering the SAT and ACT. Our diagnostic is designed to analyze your strengths and weaknesses across both tests, providing you with insights into which test aligns best with your skills and preferences.
                            </p>
                        </div>
                    </div>
                    
                    <div className='testFinder__feature'>
                        <MdOutlineInsights className='testFinder__featureIcon' />
                        <div className='testFinder__featureContent'>
                            <h3 className='testFinder__featureTitle'>Personalized Results</h3>
                            <p className='testFinder__featureDesc'>
                                You will receive a personalized recommendation at the end: SAT, ACT, or Either—based on your performance. 
                            </p>
                        </div>
                    </div>
                    
                    <div className='testFinder__feature'>
                        <MdAccessTime className='testFinder__featureIcon' />
                        <div className='testFinder__featureContent'>
                            <h3 className='testFinder__featureTitle'>Timing</h3>
                            <p className='testFinder__featureDesc'>
                                Total estimated time: ~31 minutes. We strongly recommend taking the diagnostic in a quiet environment without distractions to get the most accurate recommendation.
                            </p>
                        </div>
                    </div>
                </div>
                
                <Button
                    className='testFinder__button'
                    onClick={handleStartClick}
                >
                    Start Diagnostic
                </Button>
            </div>

            {/* Auth Modal */}
            {showAuthModal && (
                <TestFinderAuth onClose={() => setShowAuthModal(false)} />
            )}
        </div>
    );
}

export default TestFinder;
